import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { parseAlerts } from '../../../redux/alerts';
import { createHTMLText } from '../../../helpers/textFunctions';
import { PVWarningModal } from '../ContentContainers/PVModals';

function PVUpdateCartErrorModal({
    rawErrors,
    isOpen,
    onRequestClose,
    itemId,
    allowPartialSuccess,
}) {
    const isMounted = useRef();
    const [errorMessage, setErrorMessage] = useState('');
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        const errorObjects = parseAlerts(rawErrors) || [];
        if (isMounted.current) {
            if (allowPartialSuccess && errorObjects.length > 0) {
                let errMessage = '';
                for (let i = 0; i < errorObjects.length; i += 1) {
                    if (errorObjects[i].message) {
                        errMessage = `${errMessage} <br/> ${errorObjects[i].message}`;
                    }
                }
                setErrorMessage(errMessage);
            } else if (errorObjects.length > 0 && errorObjects[0] && errorObjects[0].message) {
                setErrorMessage(errorObjects[0].message);
            } else {
                setErrorMessage(
                    `Unable to make cart changes ${itemId.length > 0 ? `for item ${itemId}` : ''}.`
                );
            }
        }
    }, [rawErrors]);
    // eslint-disable-next-line react/no-danger
    const body = <div dangerouslySetInnerHTML={createHTMLText(errorMessage)} />;
    const footer = (
        <button type="submit" className="pv btn btn-primary" onClick={onRequestClose}>
            OK
        </button>
    );

    return (
        <PVWarningModal
            className="modal-dialog"
            overlayClasName="modal-overlay"
            shouldCloseOnOverlayClick
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            headerContent={
                allowPartialSuccess
                    ? 'Warning: Not All Items Added'
                    : 'Error: Could Not Update Cart'
            }
            bodyContent={body}
            footerContent={footer}
        />
    );
}

PVUpdateCartErrorModal.propTypes = {
    rawErrors: PropTypes.arrayOf(PropTypes.object).isRequired,
    itemId: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    allowPartialSuccess: PropTypes.bool,
};
PVUpdateCartErrorModal.defaultProps = {
    itemId: '',
    allowPartialSuccess: false,
};

export default PVUpdateCartErrorModal;
